import { useEffect, useState } from "react";

const ApartmentAfterContent = () => {
  const COLORS = {
    primaryGreen: "#5ec250",
    lightGray: "#f0f0f0",
    border: "#e0e0e0",
  };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 768);
    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const styles = {
    container: {
      maxWidth: "1100px",
      margin: "0 auto",
      padding: isMobile ? "40px 16px" : "60px 20px",
      overflowX: "hidden",
      fontFamily: "'Plus Jakarta Sans', sans-serif",
    },

    title: {
      fontSize: isMobile ? "22px" : "26px",
      fontWeight: 500,
      lineHeight: 1.3,
      marginBottom: "20px",
      color: "#494040",
    },

    highlight: {
      color: COLORS.primaryGreen,
    },

    description: {
      fontSize: isMobile ? "16px" : "18px",
      lineHeight: 1.8,
      color: "#454343",
      marginBottom: "18px",
    },

    faqSection: {
      marginTop: "50px",
      background: "#f9f9f9",
      padding: "30px",
      borderRadius: "18px",
    },

    faqTitle: {
      fontSize: "24px",
      fontWeight: "600",
      marginBottom: "20px",
      textAlign: "center",
      color: "#333",
    },

    faqItem: {
      marginBottom: "20px",
      borderBottom: "1px solid #ddd",
      paddingBottom: "15px",
    },

    faqQuestion: {
      fontSize: "18px",
      fontWeight: "600",
      color: "#444",
      marginBottom: "8px",
    },

    faqAnswer: {
      fontSize: "16px",
      color: "#666",
      lineHeight: "1.6",
    },

    topSection: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
      gap: "40px",
      marginBottom: "50px",
    },

    topLeft: {
      textAlign: isMobile ? "center" : "left",
    },

    topRight: {
      display: "flex",
      justifyContent: isMobile ? "center" : "start",
    },

    imageWrapper: {
      position: "relative",
      maxWidth: "420px",
    },

    topImage: {
      width: "100%",
      borderRadius: "18px",
      objectFit: "cover",
      position: "relative",
      zIndex: 2,
    },

    tiltBg: {
      position: "absolute",
      top: "14px",
      width: "100%",
      height: "80%",
      background: "#e5e5e5",
      borderRadius: "18px",
      transform: "rotate(-4deg)",
      zIndex: 1,
    },

    bottomGrid: {
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "2fr 3fr",
      gap: "28px",
      alignItems: "stretch",
    },

    greenCard: {
      background: COLORS.primaryGreen,
      color: "#fff",
      padding: "26px",
      borderRadius: "5px",
      fontSize: "15px",
      lineHeight: 1.5,
    },

    whiteCard: {
      background: "#fff",
      border: "1px solid #ddd",
      padding: "28px",
      borderRadius: "18px",
      height: "100%",
    },

    imageWrapperGrid: {
      gridColumn: isMobile ? "auto" : "2",
      height: "100%",
    },

    imageCard: {
      width: "100%",
      height: "100%",
      borderRadius: "18px",
      objectFit: "cover",
    },
  };

  const faqs = [
    {
      q: "What types of apartments can I find in Trichy?",
      a: "You can choose from 2BHK, 3BHK, and premium apartment configurations depending on your budget and lifestyle requirements.",
    },
    {
      q: "What amenities do apartments in Trichy typically offer?",
      a: "Most apartments include 24/7 security, parking, power backup, and lifts. Premium projects may also include gyms, clubhouses, and landscaped spaces.",
    },
    {
      q: "Is buying an apartment in Trichy a good investment?",
      a: "Yes, Trichy's growing infrastructure, education, and employment hubs make it a strong real estate market with promising long-term returns.",
    },
    {
      q: "What should I check before buying an apartment in Trichy?",
      a: "Always verify legal approvals, builder reputation, RERA registration, location, total cost, and nearby civic infrastructure.",
    },
    {
      q: "Are home loans available for apartments in Trichy?",
      a: "Yes, leading banks and NBFCs offer competitive home loan rates for apartments in Trichy based on your income and eligibility.",
    },
    {
      q: "Why choose Mitha Homes for apartments in Trichy?",
      a: "Mitha Homes is a trusted builder with a proven track record, delivering quality-constructed apartments with modern amenities at prime Trichy locations.",
    },
  ];

  return (
    <div style={styles.container}>
      {/* ---------- TOP ---------- */}
      <div style={styles.topSection}>
        <div style={styles.topLeft}>
          <h2 style={styles.title}>
            High budgets Apartment in Trichy for sale <br />
            <span style={styles.highlight}>Experience Space, Style & Modern Comfort</span>
          </h2>

          <p style={styles.description}>
            Discover the perfect apartment at Mitha Homes, where thoughtful design meets comfort and elegance. Our projects redefine apartment sale in Trichy by offering homes that cater to families seeking space, style, and a contemporary lifestyle.
            <br />
            Choose from spacious layouts including 3BHK apartment, crafted with attention to detail. Each home features expansive living areas, smartly planned bedrooms, modern kitchens, and stylish bathrooms—creating a perfect balance of functionality and sophistication.
            <br />
            If you’re looking for luxury apartments in Trichy or high budget apartments in Trichy for sale, Mitha Homes delivers premium residences located in well-connected neighborhoods. With close proximity to leading schools, hospitals, shopping hubs, and major transport routes, our apartments ensure convenience, comfort, and long-term value for homeowners and investors alike.
          </p>
        </div>

        <div style={styles.topRight}>
          <div style={styles.imageWrapper}>
            <div style={styles.tiltBg}></div>
            <img
              src="https://mithahomes.com/backend/uploads/home/image1.png"
              alt="Luxury Apartments Trichy"
              style={styles.topImage}
            />
          </div>
        </div>
      </div>

      {/* ---------- BOTTOM GRID ---------- */}
      <div style={styles.bottomGrid}>
        <div style={styles.greenCard}>
          <h2 style={{ ...styles.title, color: "#fff" }}>
            Luxury Living with Elegance &amp; Comfort
          </h2>
          <p>
            Discover a premium apartment for sale in Trichy with Mitha Homes, designed for those who seek elegance, comfort, and a modern lifestyle. Our apartments are crafted with top-grade materials, contemporary architecture, and high-end finishes to deliver a truly refined living experience.<br /><br />
            Each apartments in Trichy is thoughtfully planned to offer spacious interiors, stylish designs, and premium amenities that enhance your everyday living.<br /><br />
            Located in prime residential areas, these apartments provide excellent connectivity to key parts of the city, along with easy access to schools, hospitals, and shopping destinations.
          </p>
        </div>

        <div style={styles.whiteCard}>
          <h2 style={styles.title}>Find the Perfect Luxury Apartment in Trichy at Prime Locations</h2>
          <p style={styles.description}>
            At Mitha Homes, we bring you a handpicked collection of apartment for sale in Trichy situated in some of the city’s most sought-after locations. Whether you're a first-time homebuyer or upgrading to a larger space, our projects are designed to meet diverse lifestyle needs and budgets. <br /> <br />
            Our offerings in apartment sale in Trichy include thoughtfully planned 2BHK and 3BHK apartment for sale in Trichy, along with secure gated community residences. Each home is built with a focus on modern living, combining functionality, comfort, and style.<br /> <br />
            From luxury apartments in Trichy to high budget apartments in Trichy for sale, our properties provide excellent connectivity, premium amenities, and a high standard of living—making them ideal for both families and smart investors.
          </p>
        </div>

        <div style={styles.whiteCard}>
          <h2 style={styles.title}>Enjoy a Premium Lifestyle with Gated Community Apartments</h2>
          <p style={styles.description}>
            Step into a better way of living with our luxury apartments in Trichy, designed for safety, comfort, and peace of mind.<br /><br />
            These residential communities offer:<br />
            • Round-the-clock security<br />
            • Beautifully maintained green spaces<br />
            • Organised parking facilities<br />
            • Family-friendly environment<br /><br />
            Living in a gated community not only enhances your lifestyle but also provides a secure and peaceful atmosphere for you and your loved ones.
          </p>
        </div>

        <div style={styles.imageWrapperGrid}>
          <img
            src="https://mithahomes.com/backend/uploads/home/image8.jpg"
            alt="Apartment Building Trichy"
            style={styles.imageCard}
          />
        </div>
      </div>

      {/* ---------- FAQ ---------- */}
      <div style={styles.faqSection}>
        <h2 style={styles.faqTitle}>FAQs – Buying Flats in Trichy</h2>
        {faqs.map((f, i) => (
          <div key={i} style={styles.faqItem}>
            <p style={styles.faqQuestion}>{f.q}</p>
            <p style={styles.faqAnswer}>{f.a}</p>
          </div>
        ))}
      </div>

      <div
        style={{
          marginTop: "40px",
          textAlign: "center",
          padding: "40px",
          background: "#333",
          color: "#fff",
          borderRadius: "18px",
        }}
      >
        <h2 style={{ color: "#fff" }}>Begin Your Journey to the Perfect Resedential Apartments with Mitha Homes</h2>
        <p style={{ fontSize: "18px", marginTop: "10px" }}>
          At Mitha Homes, we are dedicated to helping you discover the ideal apartment for sale in Trichy that aligns with your lifestyle, preferences, and long-term goals. Whether you're looking for a modern family home or a smart investment, we offer the right choices in apartment sale in Trichy. <br /> <br />
          Connect with us today and take the first step toward owning a home that truly reflects your dreams and aspirations.

        </p>
      </div>
    </div>
  );
};

export default ApartmentAfterContent;
